import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './Pages/Home/Home/Home';
import About from './Pages/About/About';
import Contact from './Pages/Contact/Contact';
import Works from './Pages/Works/Works';
import Blogs from './Pages/Blogs/Blogs';
import Jetaway from './Pages/Jetaway/Jetaway';
import Quato from './Pages/Quato/Quato';
import Medisure from './Pages/Medisure/Medisure';
import Educapedia from './Pages/Educapedia/Educapedia';
import Macbook from './Pages/Macbook/Macbook';
import Honda from './Pages/Honda/Honda';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/'>
          <Home />
        </Route>
        <Route path='/home'>
          <Home />
        </Route>
        <Route path='/about'>
          <About />
        </Route>
        <Route path='/contact'>
          <Contact />
        </Route>
        <Route path='/work'>
          <Works />
        </Route>
        <Route path='/blog'>
          <Blogs />
        </Route>
        <Route path='/jetaway'>
          <Jetaway />
        </Route>
        <Route path='/quato'>
          <Quato />
        </Route>
        <Route path='/medisure'>
          <Medisure />
        </Route>
        <Route path='/educapedia'>
          <Educapedia />
        </Route>
        <Route path='/macbook'>
          <Macbook />
        </Route>
        <Route path='/honda'>
          <Honda />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
